module.exports = __webpack_public_path__ + "static/canapply-complete-9025d27323f627b0fd3bf8b116b43735.jpg";